import PrimeRiskAssessmentContainer from "containers/jarivsPrime/PrimeRisskAssessment";
import React from "react";

const PrimeRiskAssessment = (props) => {
  return (
    <>
      <PrimeRiskAssessmentContainer/>
    </>
  );
};

export default PrimeRiskAssessment;
